module.exports = "<div [@deleteAnimation]=\"deleteState\"\n     (@deleteAnimation.done)=\"onDeleteAnimationDone($event, tag)\"\n     [style.background-color]=\"tag.backgroundColor\"\n     [style.color]=\"tag.color\"\n     class=\"app-tag\"\n     (click)=\"onTagClicked()\">{{tag.name}}</div>"


//////////////////
// WEBPACK FOOTER
// /home/agira/Desktop/BU-Intra/agira-intranet-ui/src/app/questions/tagsComponent/tag/tag.component.html
// module id = ../../../../../src/app/questions/tagsComponent/tag/tag.component.html
// module chunks = main